import { CE_MODAL_CLOSE } from "@js/actions/studio/modals.js";

export const CE_PROMPT_CHANGE_INTERFACE = "CE_PROMPT_CHANGE_INTERFACE";
export const cePromptChangeInterface = () => {
  return {
    type: CE_PROMPT_CHANGE_INTERFACE,
  };
};

export const CE_PROMPT_CHANGE_INTERFACE_ERROR =
  "CE_PROMPT_CHANGE_INTERFACE_ERROR";
export const cePromptChangeInterfaceError = (err) => {
  return {
    type: CE_PROMPT_CHANGE_INTERFACE_ERROR,
    validation_error: err,
  };
};

export const cePromptChangeInterfaceCancel = () => ({
  type: CE_MODAL_CLOSE,
});
